import styled from "styled-components";

export const Container = styled.div`
  background: radial-gradient(
    134.34% 134.34% at 50% 0%,
    #1f3757 0%,
    #131537 100%
  );
  height: 100vh;
  width: 100vw;
  padding: 32px;
  box-sizing: border-box;
`;
